window.addEventListener('DOMContentLoaded', () => {
    const hideParentContainer = (el) => {
        el.style.visibility = 'hidden';
        el.style.height = '0';
    };
    const showParentContainer = (el) => {
        el.style.visibility = 'visible';
        el.style.height = 'auto';
    };
    // Grommets
    const customGrommetField = document.querySelector('input[name="custom_grommets_field"]');
    const customGrommetFieldParent = customGrommetField ? customGrommetField.closest('.calc-row') : null;
    const grommetDropdown = document.querySelector('select[name="grommets_field"]');
    // Pole Pocket
    const customPolePocketField = document.querySelector('input[name="custom_pole_pocket_field"]');
    const customPolePocketFieldParent = customPolePocketField ? customPolePocketField.closest('.calc-row') : null;
    const polePocketDropdown = document.querySelector('select[name="pole_pocket_field"]');
    if (customGrommetFieldParent && grommetDropdown && customPolePocketFieldParent && polePocketDropdown) {
        hideParentContainer(customGrommetFieldParent);
        hideParentContainer(customPolePocketFieldParent);
        grommetDropdown.addEventListener('change', e => {
            const target = e.target;
            const grommetSelectedOption = target.options[target.selectedIndex];
            const grommetLabel = grommetSelectedOption.getAttribute('data-label');
            if (grommetLabel === 'Custom Grommets') {
                showParentContainer(customGrommetFieldParent);
            } else {
                hideParentContainer(customGrommetFieldParent);
            }
        });

        polePocketDropdown.addEventListener('change', e => {
            const target = e.target;
            const polePocketSelectedOption = target.options[target.selectedIndex];
            const polePocketLabel = polePocketSelectedOption.getAttribute('data-label');
            if (polePocketLabel === 'Custom Pole Pocket') {
                showParentContainer(customPolePocketFieldParent);
            } else {
                hideParentContainer(customPolePocketFieldParent);
            }
        });

        navigation.addEventListener('navigate', (event) => {
            const url = new URL(event.destination.url);
            const newParam = url.searchParams.get('variant');
            setTimeout(() => {
                if (newParam) {
                    // Grommets
                    const currentCustomGrommetField = document.querySelector('input[name="custom_grommets_field"]');
                    const currentCustomGrommetFieldParent = currentCustomGrommetField ? currentCustomGrommetField.closest('.calc-row') : null;
                    const currentGrommetDropdown = document.querySelector('select[name="grommets_field"]');
                    hideParentContainer(currentCustomGrommetFieldParent);
                    currentGrommetDropdown.removeEventListener('change', e => {
                        const target = e.target;
                        const grommetSelectedOption = target.options[target.selectedIndex];
                        const grommetLabel = grommetSelectedOption.getAttribute('data-label');
                        if (grommetLabel === 'Custom Grommets') {
                            showParentContainer(currentCustomGrommetFieldParent);
                        } else {
                            hideParentContainer(currentCustomGrommetFieldParent);
                        }
                    });
                    currentGrommetDropdown.addEventListener('change', e => {
                        const target = e.target;
                        const grommetSelectedOption = target.options[target.selectedIndex];
                        const grommetLabel = grommetSelectedOption.getAttribute('data-label');
                        if (grommetLabel === 'Custom Grommets') {
                            showParentContainer(currentCustomGrommetFieldParent);
                        } else {
                            hideParentContainer(currentCustomGrommetFieldParent);
                        }
                    });

                    // Pole Pockets
                    const currentCustomPolePocketField = document.querySelector('input[name="custom_pole_pocket_field"]');
                    const currentCustomPolePocketFieldParent = currentCustomPolePocketField ? currentCustomPolePocketField.closest('.calc-row') : null;
                    const currentPolePocketDropdown = document.querySelector('select[name="pole_pocket_field"]');
                    hideParentContainer(currentCustomPolePocketFieldParent);
                    currentPolePocketDropdown.removeEventListener('change', e => {
                        const target = e.target;
                        const polePocketSelectedOption = target.options[target.selectedIndex];
                        const polePocketLabel = polePocketSelectedOption.getAttribute('data-label');
                        if (polePocketLabel === 'Custom Pole Pocket') {
                            showParentContainer(currentCustomPolePocketFieldParent);
                        } else {
                            hideParentContainer(currentCustomPolePocketFieldParent);
                        }
                    });
                    currentPolePocketDropdown.addEventListener('change', e => {
                        const target = e.target;
                        const polePocketSelectedOption = target.options[target.selectedIndex];
                        const polePocketLabel = polePocketSelectedOption.getAttribute('data-label');
                        if (polePocketLabel === 'Custom Pole Pocket') {
                            showParentContainer(currentCustomPolePocketFieldParent);
                        } else {
                            hideParentContainer(currentCustomPolePocketFieldParent);
                        }
                    });
                }
            }, 250);
        });
    }

});

